import XLSX, { WorkBook, WorkSheet } from "xlsx";
import { XLSXClientInterface } from "../interfaces/XLSXClientInterface";

export class XLSXClient implements XLSXClientInterface {

    getBookFromJSON(data: Record<string, string | number>[]) {
        const book = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(data));

        return book;
    }

    getArrayBufferFromBook(book: WorkBook) {
        return XLSX.write(book, { bookType: 'xlsx', bookSST: false, type: 'array' }) as ArrayBuffer;
    }

    convertSheetToJson<T>(sheet: WorkSheet) {
        return XLSX.utils.sheet_to_json<T>(sheet, { rawNumbers: true, defval: null });
    }

    readFromBuffer(buffer: ArrayBuffer) {
        return XLSX.read(buffer, {
            type: "buffer",
            cellFormula: false,
            cellText: false,
            raw: true,
            cellHTML: false
        });
    }
}